import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  GetIncidentsForUserQuery,
  GetIncidentsForUserQueryVariables,
} from '@investigator/shared/generated/graphql';

export const GET_INCIDENTS_FOR_USER = gql`
  query getIncidentsForUser(
    $tenant: String!
    $userId: String!
    $provider: EDRConfigurationType!
  ) {
    getIdentityIncidentsByUser(
      tenant: $tenant
      user_id: $userId
      provider_name: $provider
      offset: 0
      size: 100
    ) {
      id
      timestamp
      incident {
        incident_id
        type
        severity
        start_time
        end_time
        compromised_entities {
          entity_id
          primary_display_name
          type
        }
        timeline {
          event_type
          timestamp
          alert_type
          alert_id
          pattern_id
          entities {
            primary_display_name
          }
        }
      }
    }
  }
`;

export const useGetIncidentsForUserQuery = (
  options: QueryHookOptions<
    GetIncidentsForUserQuery,
    GetIncidentsForUserQueryVariables
  >,
) =>
  useQuery<GetIncidentsForUserQuery, GetIncidentsForUserQueryVariables>(
    GET_INCIDENTS_FOR_USER,
    options,
  );
